import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token on mount
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken');
      const savedAdmin = localStorage.getItem('admin');
      
      console.log('Checking auth - Token exists:', !!token);
      console.log('Checking auth - Saved admin exists:', !!savedAdmin);
      
      if (token && savedAdmin) {
        try {
          // Verify token with backend
          const response = await axios.get('https://files.bihebari.com/api/admin/verify', {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          if (response.data.success) {
            setAdmin(JSON.parse(savedAdmin));
            console.log('Auth verified successfully');
          } else {
            // Token invalid, clear storage
            console.log('Token invalid, clearing storage');
            localStorage.removeItem('adminToken');
            localStorage.removeItem('admin');
            setAdmin(null);
          }
        } catch (error) {
          console.error('Token verification error:', error);
          // Don't clear token on network error, just set admin from storage
          if (error.response?.status === 401) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('admin');
            setAdmin(null);
          } else {
            // Network error, still try to use stored admin
            setAdmin(JSON.parse(savedAdmin));
          }
        }
      } else if (savedAdmin) {
        // If we have saved admin but no token, still set admin
        setAdmin(JSON.parse(savedAdmin));
      }
      
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      console.log('Attempting login...');
      
      const response = await axios.post('https://files.bihebari.com/api/admin/login', {
        email,
        password
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 10000
      });
      
      console.log('Login response:', response.data);
      
      if (response.data.success) {
        // Store token and admin data
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('admin', JSON.stringify(response.data.admin));
        setAdmin(response.data.admin);
        
        toast.success('Login successful!');
        return true;
      } else {
        toast.error(response.data.message || 'Login failed');
        return false;
      }
    } catch (error) {
      console.error('Login error details:', error);
      
      if (error.code === 'ECONNABORTED') {
        toast.error('Connection timeout. Please check if server is running.');
      } else if (error.response) {
        toast.error(error.response.data?.message || 'Login failed');
      } else if (error.request) {
        toast.error('Cannot connect to server. Please check if backend is running');
      } else {
        toast.error('Login failed: ' + error.message);
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('admin');
    setAdmin(null);
    toast.success('Logged out successfully');
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};